enum PictureBingoPrizeType {
  Jackpot = 'jackpot',
  FullHouse = 'houseprize',
  TwoLine = 'twoprize',
  OneLine = 'lineprize'
}

function getPrizeTypeName(prizeType: PictureBingoPrizeType): string {
    switch (prizeType) {
      case PictureBingoPrizeType.FullHouse:
        return 'Full House';
      case PictureBingoPrizeType.Jackpot:
        return 'Jackpot';
      case PictureBingoPrizeType.OneLine:
        return 'One Line';
      case PictureBingoPrizeType.TwoLine:
        return 'Two Lines';
    }
}

export { PictureBingoPrizeType, getPrizeTypeName };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/implementations/uk/picture-bingo/_domain/models/prize-type.ts